export function isMemberImportPreviewResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const item = value;
    return (typeof item.sourceSheet === 'string' &&
        typeof item.generatedAt === 'string' &&
        Array.isArray(item.rows) &&
        ['total', 'valid', 'warning', 'error'].every((k) => Number.isInteger(item[k])) &&
        item.rows.every((r) => typeof r.id === 'string' &&
            Number.isInteger(r.rowNumber) &&
            ['valid', 'warning', 'error'].includes(r.kind) &&
            Array.isArray(r.issues) &&
            typeof r.original === 'object' &&
            typeof r.normalized === 'object'));
}
